import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { RootState } from 'stores/store';

/**
 * A generally suspended company is only allowed to read its data, so every option that creates or
 * updates a record has to be blocked. Spread `suspendedProps` on such a button to disable it and
 * explain why through its tooltip.
 */
const useCompanySuspended = () => {
	const { t } = useTranslation();

	const company = useSelector((state: RootState) => state.company);
	const admin = useSelector((state: RootState) => state.admin);


	const isGeneralSuspended = company?.profile_status === 'GeneralSuspended';

	return {
		isGeneralSuspended,
		suspendedProps: {
			disabled: isGeneralSuspended,
			disabledText: isGeneralSuspended ? t('COMMON.COMPANY_GENERAL_SUSPENDED') : undefined,
		},
	};
};

export default useCompanySuspended;
